import type { SVGProps } from 'react'

const SvgDrag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3H12V5H10V3ZM14 3H16V5H14V3ZM10 7H12V9H10V7ZM14 7H16V9H14V7ZM10 11H12V13H10V11ZM14 11H16V13H14V11ZM10 15H12V17H10V15ZM14 15H16V17H14V15ZM10 19H12V21H10V19ZM14 19H16V21H14V19Z"
      fill="#666666"
    />
  </svg>
)

export default SvgDrag
